import React from "react";
import { makeStyles } from "@mui/styles";
import GenericButton from "../Button";
import passwordChanged from "../../../../assets/updated/popup/passchanged.svg";

const useStyles = makeStyles((theme) => ({
  dataShow: {
    opacity: "1 !important",
    visibility: "visible !important",
    "& .bnModalWrap": {
      transform: "scale(1) !important",
    },
  },
  bidsFullModal: {},
  bnMask: {
    alignItems: "center",
    backgroundColor: " rgba(0, 0, 0, .5)",
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
    zIndex: 1200,
    width: "100%",
    height: "100vh",
  },
  bnTrans: {
    opacity: 0,
    transitionDuration: "250ms",
    transitionProperty: "all",
    transitionTimingFunction: "ease-in-out",
    visibility: "hidden",
  },
  bnModal: {
    "& .bnModalWrap": {
      backgroundColor: theme?.palette?.mode === "light" ? "#ffffff" : "#1e2329",
      borderRadius: "16px",
      boxShadow: "0px 3px 6px rgba(0,0,0,.04)",
      maxWidth: "80vw",
      overflow: "hidden",
      position: "relative",
      transform: "scale(.9)",
      transitionDuration: "250ms",
      transitionProperty: "all",
      transitionTimingFunction: "ease-in-out",
      width: "360px",
    },
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px",
    textAlign: "center",
    color: `${theme?.palette?.text?.primary} !important`,
    "& h3": {
      color: `${theme?.palette?.text?.primary} !important`,
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: "28px",
      marginTop: "10px",
    },
    "& h4": {
      color: `${theme?.palette?.text?.primary} !important`,
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "22px",
      margin: "10px 0px 15px 0px",
    },
    "& p": {
      color: `${theme?.palette?.text?.primary} !important`,
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "22px",
    },
  },
  btnContainer: {
    display: "flex",
    width: "100%",
    gap: "15px",
    marginTop: "25px",
  },
  cancelButton: {
    background:
      theme?.palette?.mode === "light"
        ? "#EAECEF !important"
        : "#2B3139 !important",
    color: `${theme?.palette?.text?.primary} !important`,
  },
}));

const Popup = ({ onClose }) => {
  const classes = useStyles();
  return (
    <div
      className={`${classes.bnTrans} ${classes.dataShow} ${classes.bnMask} ${classes.bnModal}  ${classes.bidsFullModal}`}
    >
      <div className="bnModalWrap">
        <div className={classes.contentContainer}>
          <img
            src={passwordChanged}
            height="100px"
            alt="password change icon"
          />
          <h3>Password Changed</h3>
          <p>
            Your password has been successfully changed. Please log in with the
            new password.
          </p>
          <div className={classes.btnContainer}>
            <GenericButton text="Login" onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
